import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Reusable page hero banner with breadcrumb
const PageHero = ({ title, subtitle, crumb }) => {
  return (
    <section className="relative bg-ktc-green text-ktc-ivory overflow-hidden">
      <div className="absolute inset-0 grain-texture opacity-60" />
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, #C9A24B 0, transparent 40%), radial-gradient(circle at 85% 80%, #C9A24B 0, transparent 45%)' }}
      />
      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-20">
        <nav className="flex items-center gap-1.5 text-xs text-ktc-ivory/60 mb-5">
          <Link to="/" className="hover:text-ktc-goldLight">Home</Link>
          <ChevronRight size={13} />
          <span className="text-ktc-goldLight">{crumb || title}</span>
        </nav>
        <h1 className="font-serif text-4xl md:text-5xl font-semibold text-balance max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-ktc-ivory/75 max-w-2xl text-[15px] leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;
